import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Navigation, Autoplay, A11y, EffectFade } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { fetchSliderData } from "../features/Slider/SliderSlice";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { LazyLoadImage } from "react-lazy-load-image-component";
import Loading from "./Loading";

function Slider({ settings }) {
  const dispatch = useDispatch();
  const { slides, loading } = useSelector((state) => state.slider);
  const [selectedType, setSelectedType] = useState("all");
  const { i18n } = useTranslation();

  useEffect(() => {
    
    dispatch(fetchSliderData({ type: selectedType }));
  }, [dispatch, i18n.language, selectedType]);

  
  const handleChange = (type) => setSelectedType(type);

  // if (loading) return <Loading />
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col justify-center mt-4 px-4"
    >
      {/* <Slider1/> */}

      {slides?.length > 0 && (
        <Swiper
          key={`${selectedType}__${i18n.language}`}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          modules={[Navigation, Autoplay, A11y, EffectFade]}
          navigation={{
            nextEl: localStorage.getItem("lang") == "ar" || localStorage.getItem("lang") == "ckb" ? ".prev" : ".next",
            prevEl: localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") == "ckb" ? ".next" : ".prev",
            clickable: true,
          }}
          pagination={{ clickable: true, dynamicBullets: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop
          className="w-full max-w-[1200px] rounded-xl shadow-lg relative mx-auto overflow-hidden"
          style={{ aspectRatio: '1200 / 480' }}
        >
          {slides?.map((slide, index) => (
            <SwiperSlide key={slide.id}>
              <Link to={slide.link ?? "#"}>
                <div className="relative w-full h-full">
                  <LazyLoadImage
                    src={process.env.REACT_APP_IMG_URL + slide.image}
                    alt={slide.title}
                    className="absolute inset-0 w-full h-full object-cover"
                  // effect="blur"
                  />
                  {/* <img
                      src={process.env.REACT_APP_IMG_URL + slide.image}
                      alt={slide.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    /> */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 via-transparent to-transparent" />
                  <div className="absolute top-1/4 left-1/4 md:top-1/3 md:left-1/3 z-10">
                    <h2
                      className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 drop-shadow-lg"
                      dangerouslySetInnerHTML={{ __html: slide.main_text }}
                    />
                    <p
                      className="text-white text-sm sm:text-base md:text-lg drop-shadow-md max-w-md"
                      dangerouslySetInnerHTML={{ __html: slide.description?.length > 120 ? slide.description.slice(0, 120) + '...' : slide.description }}
                    />
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}


          <div className="next absolute top-1/2 right-4 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full w-8 h-8 md:w-12 md:h-12 hidden md:flex items-center justify-center z-20 transition">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
          <div className="prev absolute top-1/2 left-4 -translate-y-1/2 bg-black/40 hover:bg-black/60 text-white rounded-full w-8 h-8 md:w-12 md:h-12 hidden md:flex items-center justify-center z-20 transition">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </Swiper>
      )}


      <div className="hidden lg:flex w-full justify-center items-center mt-4 gap-3 ">
        {settings?.map((item, index) => (
          <button
            key={index}
            disabled={loading}
            onClick={() => handleChange(item.value)}
            className={`text-white ${loading ? "cursor-not-allowed opacity-45" : ""}  text-sm md:text-lg px-6 py-2 shadow-md bg-gradient-to-br from-green-600 to-green-800 rounded-md transition`}
          >
            {item.value}
          </button>
        ))}
      </div>
    </motion.div>
  );
}

export default Slider;
